import React from 'react'

import styles from './_errorPage.module.scss'
import Icon from '../Icons/Icon'
import { c } from '../../translations/LibraryTranslationService'

interface ErrorPageProps {
  logo: React.ReactNode
  icon?: React.ReactNode
  title?: string
  message?: string
  supportMessage: React.ReactNode
  thankYouMessage?: string
  copyrightYear?: number
  copyrightName?: string
  /** Optional prop to add a test id to the ErrorPage for QA testing */
  qaTestId?: string
}

const ErrorIcon: React.FC = () => <Icon icon='errorWarning' />

const EmailLink: React.FC<{ email: string }> = ({ email }) => (
  <a href={`mailto:${email}`} className={styles.supportLink}>
    {email}
  </a>
)

const ErrorPage: React.FC<ErrorPageProps> & { EmailLink: typeof EmailLink } = ({
  logo,
  icon = <ErrorIcon />,
  title = c('erroTitle'),
  message = c('errorMessage'),
  supportMessage,
  thankYouMessage = c('errorThankYou'),
  copyrightYear = new Date().getFullYear(),
  copyrightName = c('pattern'),
  qaTestId = 'error-page',
}) => {
  return (
    <div className={styles.errorPage} qa-test-id={qaTestId}>
      <div className={styles.logo}>{logo}</div>
      <div className={styles.content}>
        <div className={styles.icon}>{icon}</div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.message}>{message}</p>
        <p className={styles.message}>{supportMessage}</p>
        <p className={styles.message}>{thankYouMessage}</p>
      </div>
      <div className={styles.footer}>
        <p className={styles.copyright}>
          © {copyrightYear}, {copyrightName}
        </p>
      </div>
    </div>
  )
}

ErrorPage.EmailLink = EmailLink

export default ErrorPage
